import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const split = defineConnector({
  identifier: "split",
  name: "Split",
  tagLine: "Feature flags and experiments",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://api\\.split\\.io/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your Split API key",
      items: [
        {
          kind: "markdown",
          content:
            "In your Split dashboard, navigate to **Admin Settings > API Keys** and create a new Admin API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "Admin API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText: "Your Split Admin API key",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.split.io/internal/api/v2/splits",
  },
});
